// extracted by mini-css-extract-plugin
export default {"mod":"Mod_mod__NHCMX","modInner":"Mod_modInner__RSlyG","infoWrapper":"Mod_infoWrapper__RYUX-"};